document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".categories-item").forEach((item) => {
    item.addEventListener("click", function (event) {
      if (!event.target.classList.contains("categories-item_span")) {
        const link = this.querySelector(".full-link");
        if (link) {
          window.location.href = link.href;
        }
      }
    });
  });
});
  